/* Paqari v2 — storefront interactions.
   Cart engine, add-to-cart tracking and the bag drawer stay in paqari-product.js.
   This file adds: dated content, announcement rotation, header + mega menu,
   mobile drawer, tabs, PDP gallery + zoom, delivery estimate, gift options. */
(function () {
  'use strict';
  var d = document, w = window;
  var S = w.paqariSettings || {};
  var reduceMotion = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  d.documentElement.classList.add('pq-js');

  function $(sel, root) { return (root || d).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }

  /* ---------- Dated content: hide anything past its data-until day ---------- */
  function todayISO() {
    var t = new Date();
    return t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
  }
  var today = todayISO();
  $$('[data-until]').forEach(function (el) {
    var until = (el.getAttribute('data-until') || '').trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(until) && today > until) {
      el.hidden = true;
      el.setAttribute('data-expired', '');
    }
  });

  /* ---------- Announcement bar ---------- */
  $$('[data-pq-announce]').forEach(function (bar) {
    var msgs = $$('.pq-announce__msg', bar).filter(function (m) { return !m.hasAttribute('data-expired'); });
    if (!msgs.length) { bar.hidden = true; return; }
    msgs.forEach(function (m, i) { m.classList.toggle('is-active', i === 0); });
    if (msgs.length < 2 || reduceMotion) return;
    var i = 0, paused = false;
    on(bar, 'mouseenter', function () { paused = true; });
    on(bar, 'mouseleave', function () { paused = false; });
    on(bar, 'focusin', function () { paused = true; });
    on(bar, 'focusout', function () { paused = false; });
    setInterval(function () {
      if (paused || d.hidden) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 5000);
  });

  /* ---------- Header: scrolled state + mega menu ---------- */
  var header = $('[data-pq-header]');
  if (header) {
    var setScrolled = function () { header.classList.toggle('is-scrolled', w.scrollY > 8); };
    setScrolled();
    on(w, 'scroll', setScrolled, { passive: true });

    var mega = $('[data-pq-mega]', header);
    var trigger = $('[data-pq-mega-trigger]', header);
    var closeTimer;
    var desktop = function () { return w.matchMedia('(min-width: 900px)').matches; };
    var openMega = function () {
      if (!mega || !desktop()) return;
      clearTimeout(closeTimer);
      mega.hidden = false;
      requestAnimationFrame(function () { header.classList.add('mega-open'); });
      trigger.setAttribute('aria-expanded', 'true');
    };
    var closeMega = function (now) {
      if (!mega) return;
      var doClose = function () {
        header.classList.remove('mega-open');
        trigger.setAttribute('aria-expanded', 'false');
        mega.hidden = true;
      };
      clearTimeout(closeTimer);
      if (now) doClose(); else closeTimer = setTimeout(doClose, 160);
    };
    if (mega && trigger) {
      var item = trigger.parentElement;
      on(item, 'mouseenter', openMega);
      on(item, 'mouseleave', function () { closeMega(); });
      on(mega, 'mouseenter', function () { clearTimeout(closeTimer); });
      on(mega, 'mouseleave', function () { closeMega(); });
      on(trigger, 'focus', openMega);
      on(trigger, 'keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); openMega(); var f = $('a', mega); if (f) f.focus(); }
      });
      on(header, 'focusout', function (e) {
        if (!header.contains(e.relatedTarget)) closeMega(true);
      });
      on(d, 'keydown', function (e) { if (e.key === 'Escape' && !mega.hidden) { closeMega(true); trigger.focus(); } });
    }
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = $('[data-pq-drawer]');
  var lastFocus = null;
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    var panel = $('.pq-drawer__panel', drawer); if (panel) panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    $$('[data-pq-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    d.documentElement.classList.toggle('pq-lock', open);
    if (open) {
      lastFocus = d.activeElement;
      var first = $('.pq-drawer__x', drawer);
      if (first) setTimeout(function () { first.focus(); }, 50);
    } else if (lastFocus) {
      lastFocus.focus();
    }
  }
  $$('[data-pq-drawer-open]').forEach(function (b) { on(b, 'click', function () { setDrawer(true); }); });
  $$('[data-pq-drawer-close]').forEach(function (b) { on(b, 'click', function () { setDrawer(false); }); });
  on(d, 'keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) setDrawer(false); });
  if (drawer) $$('a', drawer).forEach(function (a) {
    on(a, 'click', function () {
      if (a.getAttribute('href') && a.getAttribute('href').charAt(0) === '/' && a.getAttribute('href').indexOf('#') > -1) setDrawer(false);
    });
  });

  /* ---------- Tabs ---------- */
  $$('[data-pq-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    if (tabs.length < 2) return;
    function select(tab) {
      tabs.forEach(function (t) {
        var active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
        var panel = d.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
    }
    tabs.forEach(function (t, i) {
      on(t, 'click', function () { select(t); });
      on(t, 'keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); select(n); n.focus(); }
      });
    });
  });

  /* ---------- PDP gallery: counter + zoom ---------- */
  var track = $('[data-pq-media-track]');
  var cur = $('[data-pq-media-cur]');
  if (track && cur) {
    var items = $$('.pq-media__item', track);
    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) cur.textContent = String(Number(en.target.getAttribute('data-index') || 0) + 1);
        });
      }, { root: null, threshold: [0.6] });
      items.forEach(function (it) { if (it.hasAttribute('data-index')) io.observe(it); });
    }
  }
  var zoom = $('[data-pq-zoom]');
  if (zoom && track) {
    var zImg = $('[data-pq-zoom-img]', zoom);
    var zLast = null;
    var closeZoom = function () {
      zoom.hidden = true;
      d.documentElement.classList.remove('pq-lock');
      if (zLast) zLast.focus();
    };
    on(track, 'click', function (e) {
      var img = e.target.closest && e.target.closest('img[data-zoom]');
      if (!img) return;
      zLast = img;
      zImg.src = img.getAttribute('data-zoom');
      zImg.alt = img.alt;
      zoom.hidden = false;
      d.documentElement.classList.add('pq-lock');
      var x = $('[data-pq-zoom-close]', zoom); if (x) x.focus();
    });
    $$('img[data-zoom]', track).forEach(function (img) { img.setAttribute('tabindex', '0'); img.setAttribute('role', 'button'); img.setAttribute('aria-label', 'Enlarge photo: ' + (img.alt || '')); });
    on(track, 'keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('img[data-zoom]')) { e.preventDefault(); e.target.click(); }
    });
    on(zoom, 'click', function (e) { if (e.target === zoom || e.target.closest('[data-pq-zoom-close]')) closeZoom(); });
    on(d, 'keydown', function (e) { if (e.key === 'Escape' && !zoom.hidden) closeZoom(); });
  }

  /* ---------- Variant select (multi-variant products only) ---------- */
  var vsel = $('[data-pq-variant-select]');
  if (vsel) {
    on(vsel, 'change', function () {
      var id = parseInt(vsel.value, 10);
      var v = (w.paqariVariants || []).filter(function (x) { return x.id === id; })[0];
      var idInput = $('#paqari-product-form [name="id"]');
      if (idInput) idInput.value = id;
      var btn = $('#pdp-atc-btn');
      if (v && btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to bag · $' + (v.price / 100).toFixed(2).replace(/\.00$/, '') : 'Sold Out';
      }
      var price = $('.buy-price-amount');
      if (v && price) price.textContent = '$' + (v.price / 100).toFixed(2).replace(/\.00$/, '');
    });
  }

  /* ---------- Delivery estimate (business days, skips weekends) ---------- */
  var eta = $('[data-pq-eta]');
  if (eta) {
    var addBiz = function (date, n) {
      var x = new Date(date.getTime());
      var added = 0;
      while (added < n) { x.setDate(x.getDate() + 1); var day = x.getDay(); if (day !== 0 && day !== 6) added++; }
      return x;
    };
    var fmt = function (x) {
      try { return x.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
      catch (e) { return x.toDateString().slice(0, 10); }
    };
    var now = new Date();
    var a = addBiz(now, parseInt(eta.getAttribute('data-min'), 10) || 3);
    var b = addBiz(now, parseInt(eta.getAttribute('data-max'), 10) || 6);
    var out = $('[data-pq-eta-range]', eta);
    if (out) { out.textContent = fmt(a) + ' – ' + fmt(b); eta.hidden = false; }
  }

  /* ---------- Gift options ---------- */
  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function cartGet() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); });
  }
  function giftState(root) {
    var c = $('[data-pq-gift-check]', root);
    var t = $('[data-pq-gift-text]', root);
    return { on: !!(c && c.checked), note: t ? t.value.trim() : '' };
  }
  function reflect(state) {
    // Keep every gift control on the page in step (PDP, drawer, cart page).
    $$('[data-pq-gift]').forEach(function (root) {
      var c = $('[data-pq-gift-check]', root);
      var t = $('[data-pq-gift-text]', root);
      var n = $('[data-pq-gift-note]', root);
      if (c) c.checked = state.on;
      if (t && d.activeElement !== t) t.value = state.note;
      if (n) n.hidden = !state.on;
    });
  }
  function writeGift(state) {
    return cartPost('/cart/update.js', {
      attributes: { 'Gift wrap': state.on ? 'Yes' : '', 'Gift note': state.on ? state.note : '' }
    }).catch(function () {});
  }
  function syncWrapProduct(state) {
    var vid = S.giftWrapVariant;
    if (!vid) return Promise.resolve(false);
    return cartGet().then(function (cart) {
      var line = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
      if (state.on && !line) {
        return cartPost('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }).then(function () { return true; });
      }
      if (!state.on && line) {
        return cartPost('/cart/change.js', { id: line.key, quantity: 0 }).then(function () { return true; });
      }
      return false;
    }).catch(function () { return false; });
  }

  $$('[data-pq-gift]').forEach(function (root) {
    var c = $('[data-pq-gift-check]', root);
    var t = $('[data-pq-gift-text]', root);
    var n = $('[data-pq-gift-note]', root);
    var isCart = root.getAttribute('data-pq-gift-scope') === 'cart';
    var timer;
    on(c, 'change', function () {
      if (n) n.hidden = !c.checked;
      if (c.checked && t && !isCart) setTimeout(function () { t.focus(); }, 30);
      if (!isCart) return;
      var st = giftState(root);
      reflect(st);
      writeGift(st).then(function () { return syncWrapProduct(st); }).then(function (changed) {
        if (!changed) return;
        if (d.body.classList.contains('template-cart')) w.location.reload();
        else if (w.paqariOpenMiniCart) w.paqariOpenMiniCart();
        if (w.paqariRefreshCartCount) w.paqariRefreshCartCount();
      });
    });
    on(t, 'input', function () {
      if (!isCart) return;
      clearTimeout(timer);
      timer = setTimeout(function () { writeGift(giftState(root)); }, 600);
    });
  });

  // Called by paqari-product.js before the PDP add, so the order is deterministic.
  w.paqariGiftSync = function () {
    var root = $('[data-pq-pdp] [data-pq-gift]');
    if (!root) return Promise.resolve();
    var st = giftState(root);
    if (!st.on) return Promise.resolve();
    reflect(st);
    return writeGift(st);
  };
  w.paqariGiftWrapAdd = function () {
    var root = $('[data-pq-pdp] [data-pq-gift]');
    if (!root) return Promise.resolve();
    var st = giftState(root);
    if (!st.on) return Promise.resolve();
    return syncWrapProduct(st);
  };

  /* ---------- Accordion aria state (toggle itself lives in paqari-product.js) ---------- */
  $$('.acc-trigger').forEach(function (b) {
    on(b, 'click', function () {
      setTimeout(function () {
        $$('.acc-item').forEach(function (it) {
          var t = $('.acc-trigger', it); if (t) t.setAttribute('aria-expanded', it.classList.contains('open') ? 'true' : 'false');
        });
      }, 0);
    });
  });

  /* ---------- Count-up figures (once, on view) ---------- */
  var counters = $$('[data-pq-count]');
  if (counters.length && !reduceMotion && 'IntersectionObserver' in w) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        cio.unobserve(en.target);
        var el = en.target, raw = el.getAttribute('data-pq-count');
        var m = raw.match(/^(\d+(?:,\d{3})*)(.*)$/);
        if (!m || /\d/.test(m[2])) return;
        var target = parseInt(m[1].replace(/,/g, ''), 10), tail = m[2], t0 = null, dur = 900;
        var fmt = function (n) { return (m[1].indexOf(',') > -1 ? n.toLocaleString('en-US') : String(n)) + tail; };
        var step = function (ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / dur);
          el.textContent = fmt(Math.round(target * (1 - Math.pow(1 - k, 3))));
          if (k < 1) requestAnimationFrame(step); else el.textContent = raw;
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { if (c.getBoundingClientRect().top > w.innerHeight) cio.observe(c); });
  }

  /* ---------- Email fields: inline validation, keep what was typed ---------- */
  $$('[data-pq-field]').forEach(function (field) {
    var form = field.closest('form');
    var input = $('input[type="email"]', field);
    var err = form && $('[data-pq-err]', form);
    if (!form || !input) return;
    var valid = function () { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim()); };
    var show = function (bad) {
      field.classList.toggle('is-invalid', bad);
      input.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (err) err.hidden = !bad;
    };
    on(form, 'submit', function (e) {
      if (!valid()) { e.preventDefault(); show(true); input.focus(); }
    });
    on(input, 'input', function () { if (field.classList.contains('is-invalid') && valid()) show(false); });
    on(input, 'blur', function () { if (input.value.trim()) show(!valid()); });
  });
  /* ---------- Mobile numbers (phone-only signups) ---------- */
  var digitsOf = function (v) { var x = String(v || '').replace(/\D/g, ''); if (x.length === 11 && x.charAt(0) === '1') x = x.slice(1); return x; };
  var prettyPhone = function (x) {
    if (x.length < 4) return x;
    if (x.length < 7) return '(' + x.slice(0, 3) + ') ' + x.slice(3);
    return '(' + x.slice(0, 3) + ') ' + x.slice(3, 6) + '-' + x.slice(6, 10);
  };
  var phoneOk = function (input) { var x = digitsOf(input.value); return x.length === 10 && /^[2-9]/.test(x); };
  function showPhoneErr(input, bad) {
    var field = input.closest('[data-pq-phone-field]');
    var form = input.closest('form');
    var err = form && $('[data-pq-phone-err]', form);
    if (field) field.classList.toggle('is-invalid', bad);
    input.setAttribute('aria-invalid', bad ? 'true' : 'false');
    if (err) err.hidden = !bad;
  }
  $$('[data-pq-phone]').forEach(function (input) {
    on(input, 'input', function () {
      var x = digitsOf(input.value).slice(0, 10);
      if (input.selectionStart === input.value.length) input.value = prettyPhone(x);
      if (input.getAttribute('aria-invalid') === 'true' && phoneOk(input)) showPhoneErr(input, false);
    });
    on(input, 'blur', function () { if (input.value.trim()) showPhoneErr(input, !phoneOk(input)); });
  });

  function klaviyo(path, body) {
    var company = S.klaviyoCompany;
    if (!company) return Promise.reject(new Error('no company'));
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      // 202 subscription / event accepted, 201 profile created, 409 profile already exists
      if (r.ok || r.status === 409) return r;
      throw new Error('klaviyo ' + r.status);
    });
  }
  function subscribePhone(phone, source, props) {
    var profile = { type: 'profile', attributes: { phone_number: phone, properties: Object.assign({ signup_source: source, signup_page: w.location.pathname }, props || {}) } };
    if (S.klaviyoList) {
      // List subscription with a phone number records SMS consent from the on-form disclosure.
      return klaviyo('subscriptions', { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: profile } }, relationships: { list: { data: { type: 'list', id: S.klaviyoList } } } } });
    }
    // No list ID yet: keep the number on the Klaviyo profile so it is not lost.
    return klaviyo('profiles', { data: profile });
  }

  $$('[data-pq-sms-form]').forEach(function (form) {
    var input = $('[data-pq-phone]', form);
    var btn = $('[type="submit"]', form);
    var sendErr = $('[data-pq-send-err]', form);
    var okEl = $('[data-pq-ok]', form);
    var fields = $('[data-pq-sms-fields]', form);
    var external = form.hasAttribute('data-pq-external');
    var busy = false;
    on(form, 'submit', function (e) {
      e.preventDefault();
      if (busy || !input) return;
      if (sendErr) sendErr.hidden = true;
      if (!phoneOk(input)) { showPhoneErr(input, true); input.focus(); return; }
      busy = true;
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-submitting') || 'Signing up…'; }
      var props = {};
      $$('[data-pq-prop]', form).forEach(function (el) { props[el.getAttribute('data-pq-prop')] = el.value; });
      subscribePhone('+1' + digitsOf(input.value), form.getAttribute('data-source') || 'Website', props).then(function () {
        busy = false;
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (!external) {
          if (fields) fields.hidden = true;
          if (okEl) { okEl.hidden = false; try { okEl.focus(); } catch (er) {} }
        }
        try { if (typeof w.gtag === 'function') w.gtag('event', 'sign_up', { method: 'sms', signup_source: form.getAttribute('data-source') }); } catch (er) {}
        try { if (typeof w.fbq === 'function') w.fbq('track', 'Lead', { content_name: form.getAttribute('data-source') }); } catch (er) {}
        form.dispatchEvent(new CustomEvent('pq:signup', { bubbles: true }));
      }).catch(function () {
        busy = false;
        if (btn) { btn.disabled = false; btn.textContent = label; }
        if (sendErr) sendErr.hidden = false;
        form.dispatchEvent(new CustomEvent('pq:signup-error', { bubbles: true }));
      });
    });
  });

  /* ---------- Ask a question: instant answers + send to the team ---------- */
  var bankEl = d.getElementById('pq-answer-bank');
  var bank = [];
  try { bank = bankEl ? JSON.parse(bankEl.textContent) : []; } catch (er) { bank = []; }
  $$('.pq-faq .pq-qa:not(.pq-ask)').forEach(function (qa) {
    var q = $('summary span', qa), a = $('.pq-qa__a', qa);
    if (q && a) bank.push({ k: '', q: q.textContent.trim(), a: a.textContent.trim() });
  });
  var STOP = /^(a|an|the|is|are|it|do|does|can|i|my|you|your|of|to|for|in|on|and|or|what|how|with|be|will|this|that|me|we)$/;
  var words = function (t) { return String(t).toLowerCase().replace(/[^a-z0-9$ ]/g, ' ').split(/\s+/).filter(function (x) { return x && !STOP.test(x); }); };
  var stem = function (x) { return x.replace(/(ing|ed|es|s)$/, ''); };
  function bestAnswers(text) {
    var qs = words(text).map(stem);
    if (!qs.length) return [];
    return bank.map(function (e) {
      var hay = words(e.k + ' ' + e.q + ' ' + e.a).map(stem);
      var score = 0;
      qs.forEach(function (x) { if (x.length > 1 && hay.indexOf(x) > -1) score += (words(e.k).map(stem).indexOf(x) > -1 ? 2 : 1); });
      return { e: e, score: score };
    }).filter(function (r) { return r.score >= 2; }).sort(function (x, y) { return y.score - x.score; })
      .filter(function (r, i, arr) { return arr.findIndex(function (o) { return o.e.q === r.e.q; }) === i; }).slice(0, 2);
  }
  var esc = function (t) { var dv = d.createElement('div'); dv.textContent = t; return dv.innerHTML; };
  $$('[data-pq-ask]').forEach(function (box) {
    var ta = $('[data-pq-ask-q]', box), out = $('[data-pq-ask-answers]', box), form = $('[data-pq-ask-form]', box);
    var lead = $('[data-pq-ask-lead]', box), okEl = $('[data-pq-ask-ok]', box);
    var timer;
    on(ta, 'input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var hits = bestAnswers(ta.value);
        out.innerHTML = hits.map(function (h) { return '<div class="pq-ask__hit"><p class="pq-ask__q">' + esc(h.e.q) + '</p><p>' + esc(h.e.a) + '</p></div>'; }).join('');
        if (lead) lead.textContent = hits.length ? 'Still need an answer? Send it to us and we will text you back.' : (lead.getAttribute('data-default') || lead.textContent);
      }, 180);
    });
    if (lead) lead.setAttribute('data-default', lead.textContent);
    if (!form) return;
    var input = $('[data-pq-phone]', form), qErr = $('[data-pq-ask-err]', form), sendErr = $('[data-pq-send-err]', form), btn = $('[type="submit"]', form);
    on(form, 'submit', function (e) {
      e.preventDefault();
      qErr.hidden = !!ta.value.trim();
      sendErr.hidden = true;
      if (!ta.value.trim()) { ta.focus(); return; }
      if (!phoneOk(input)) { showPhoneErr(input, true); input.focus(); return; }
      btn.disabled = true;
      var label = btn.textContent; btn.textContent = 'Sending…';
      klaviyo('events', { data: { type: 'event', attributes: {
        properties: { question: ta.value.trim().slice(0, 600), page: w.location.pathname, suggested_answers: bestAnswers(ta.value).map(function (h) { return h.e.q; }).join(' | ') },
        metric: { data: { type: 'metric', attributes: { name: 'Asked a question' } } },
        profile: { data: { type: 'profile', attributes: { phone_number: '+1' + digitsOf(input.value) } } }
      } } }).then(function () {
        form.hidden = true; okEl.hidden = false; try { okEl.focus(); } catch (er) {}
      }).catch(function () { sendErr.hidden = false; }).then(function () { btn.disabled = false; btn.textContent = label; });
    });
  });

  /* ---------- Twin Blanket preorder ---------- */
  var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); };
  $$('[data-pq-preorder]').forEach(function (box) {
    var variants = [];
    try { variants = JSON.parse($('[data-pq-twin-variants]', box).textContent); } catch (er) {}
    // Reservation form: keep the chosen color on the signup
    var colorProp = $('[data-pq-twin-color]', box);
    var setColor = function (name) { if (colorProp && name) colorProp.value = name; };
    $$('input[type="radio"]', box).forEach(function (r) {
      if (/pq-twin-(res|variant)/.test(r.name)) on(r, 'change', function () { if (r.checked) setColor(r.getAttribute('data-title') ? (r.closest('label').textContent || '').trim() : r.value); });
    });
    $$('.pq-tb-swatch[data-color]').forEach(function (sw) { on(sw, 'click', function () { setColor(sw.getAttribute('data-name')); }); });
    var add = $('[data-pq-preorder-add]', box), priceEl = $('[data-pq-twin-price]', box), wasEl = $('[data-pq-twin-was]', box);
    var radios = $$('input[type="radio"][value]', box).filter(function (r) { return /pq-twin-variant/.test(r.name); });
    var current = function () {
      var r = radios.filter(function (x) { return x.checked; })[0];
      var id = r ? parseInt(r.value, 10) : (variants[0] && variants[0].id);
      return variants.filter(function (v) { return v.id === id; })[0] || variants[0];
    };
    var plan = function () {
      var p = $$('input[type="radio"]', box).filter(function (r) { return /pq-twin-plan/.test(r.name) && r.checked; })[0];
      return p && p.value ? parseInt(p.value, 10) : null;
    };
    var paint = function () {
      var v = current(); if (!v) return;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) { wasEl.hidden = !(v.compare > v.price); wasEl.textContent = money(v.compare); }
      var saveEl = $('[data-pq-twin-save]', box);
      if (saveEl) { saveEl.hidden = !(v.compare > v.price); saveEl.textContent = 'You save ' + money(v.compare - v.price); }
      if (add) { add.disabled = !v.available; add.textContent = v.available ? 'Preorder · ' + money(v.price) : 'Sold out'; }
    };
    radios.forEach(function (r) { on(r, 'change', paint); });
    // Twin page: its own swatches pick the color.
    $$('.pq-tb-swatch[data-color]').forEach(function (sw) {
      on(sw, 'click', function () {
        var key = sw.getAttribute('data-color');
        var match = radios.filter(function (r) { return (r.getAttribute('data-title') || '').indexOf(key) > -1 || (key === 'gray' && (r.getAttribute('data-title') || '').indexOf('grey') > -1); })[0];
        if (match) { match.checked = true; paint(); }
      });
    });
    on(add, 'click', function () {
      var v = current(); if (!v || !w.paqariAddToCart) return;
      var label = add.textContent;
      add.disabled = true; add.textContent = 'Adding…';
      w.paqariAddToCart(v.id, { quantity: 1, properties: { 'Preorder': add.getAttribute('data-property') || 'Ships at launch' }, selling_plan: plan() })
        .then(function () {
          add.textContent = 'Added to bag';
          if (w.paqariRefreshCartCount) w.paqariRefreshCartCount();
          if (w.paqariOpenMiniCart) w.paqariOpenMiniCart();
          setTimeout(function () { add.disabled = false; add.textContent = label; }, 1600);
        })
        .catch(function (err) {
          add.textContent = (err && err.message) || 'Could not add. Try again.';
          setTimeout(function () { add.disabled = false; add.textContent = label; }, 2400);
        });
    });
    paint();
  });

  var ok = $('[data-pq-autofocus]');
  if (ok) { try { ok.focus({ preventScroll: false }); ok.scrollIntoView({ block: 'center' }); } catch (e) {} }

  /* ---------- Stagger tiles inside revealed sections ---------- */
  $$('.pq-tiles4, .pq-gift__grid, .pq-linktiles__grid').forEach(function (g) {
    Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); });
  });

  /* ---------- Quiet reveal for sections below the fold ---------- */
  if (!reduceMotion && 'IntersectionObserver' in w) {
    var vh = w.innerHeight;
    var secs = $$('main > .shopify-section').filter(function (s) { return s.getBoundingClientRect().top > vh; });
    secs.forEach(function (s) { s.classList.add('pq-rv'); });
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('pq-in'); rio.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    secs.forEach(function (s) { rio.observe(s); });
  }

  /* Free shipping promo line in the bag (threshold from theme settings) */
  (function () {
    var limit = +(S.freeShip || 0);
    var lines = $$('[data-pq-freeship]');
    if (!limit || !lines.length) return;
    function money(c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
    var busy = false;
    function refresh() {
      if (busy) return; busy = true;
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (r) { return r.json(); }).then(function (c) {
        var left = limit - (c.total_price || 0);
        lines.forEach(function (el) { el.textContent = left > 0 ? 'You are ' + money(left) + ' away from free shipping.' : 'Your order ships free.'; });
      }).catch(function () {}).then(function () { busy = false; });
    }
    ['paqariCartSubtotal'].concat([]).forEach(function (id) {
      var el = document.getElementById(id);
      if (el && w.MutationObserver) new MutationObserver(refresh).observe(el, { childList: true, characterData: true, subtree: true });
    });
    $$('.cart-subtotal-price').forEach(function (el) { if (w.MutationObserver) new MutationObserver(refresh).observe(el, { childList: true, characterData: true, subtree: true }); });
    refresh();
  })();

  /* Same-page links scroll smoothly and keep the address bar clean (no #) */
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented) return;
    var id = a.getAttribute('href').slice(1);
    if (!id || id === 'checkout') return;
    var t = d.getElementById(id);
    if (!t) return;
    e.preventDefault();
    var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (!t.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA|SUMMARY)$/.test(t.tagName)) t.setAttribute('tabindex', '-1');
    try { t.focus({ preventScroll: true }); } catch (er) {}
  });
  if (w.location.hash && w.history && w.history.replaceState) {
    var h0 = d.getElementById(w.location.hash.slice(1));
    if (h0) setTimeout(function () { h0.scrollIntoView(); }, 0);
    w.history.replaceState(null, '', w.location.pathname + w.location.search);
  }
})();
